import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const SleepHabits = lazyWithPreload(() => import('./SleepHabits'))
